// Team.jsx
import React from 'react';
import './team.css';

export default function Contact() {
  return (
    <main className="container contact">
      <h2 className="title">Management Team</h2>

      <div className="team-grid">
        <div className="team-member">
          <div className="pulse-indicator"></div>
          <h3>Cristian Ruiz</h3>
          <p>CEO &amp; Founder</p>
        </div>

        <div className="team-member">
          <div className="pulse-indicator"></div>
          <h3>NOVIONIX</h3>
          <p>Research Collective</p>
        </div>
      </div>

      <section className="vision-block">
        <h3>Motion as Time...</h3>
        <p>
          Founded in 2025, NOVIONIX Labs explores consciousness, motion, and systems through a singular lens: time is not something we pass through — it's something we <em>are</em>. 
          Our research bridges physics, string theory, quantum theory, and growth as acts of temporal navigation.
        </p>
        <p>
          <strong>"Every change is not just happening in time — it is time happening."</strong>
        </p>
        <p>
          Learn more in our foundational paper: <em>Motion as Time: A Unifying Framework for Phenomenology, Physics, and Consciousness</em> by Cristian Ruiz
        </p>
      </section>

      <div className="join-us">
        <h3>Join us</h3>
        <p>
          Want to build the future with us? <a href="https://novionix-labs-development.web.app/contact">Reach out</a>.
        </p>
      </div>
    </main>
  );
}